import { Theme } from '@mui/material/styles'

const muiInputBase = (theme: Theme) => {
  return {
    styleOverrides: {
      input: {
        padding: '0.75rem 0.875rem'
      },
      root: {
        '&:before': {
          display: 'none'
        },
        '&:after': {
          display: 'none'
        },
        '&.Mui-disabled': {
          color: theme.colors.placeholder,
          background: theme.colors.subHover
        }
      }
    }
  }
}

export default muiInputBase
